// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Kfasr","placeholdersHeader":"styles_placeholdersHeader__5te0o","editorStyle":"styles_editorStyle__1f97a","placeholdersBox":"styles_placeholdersBox__2dKvj"};